<template>
  <div class="form-card">
    <div class="form-card__inner">
      <div class="form-card__header">
        <div class="form-card__icon">
          <img
            src="@/assets/icons/card.svg"
            alt="phone"
          >
        </div>
        <h3 class="form-card__title">
          {{$t('bank_transfer.title')}}
        </h3>
        <div class="form-card__subtitle">
          {{$t('bank_transfer.subtitle')}}
        </div>
      </div>
      <div class="form-card__input">
        <ap-input-tel
          v-model="sender.phone"
          :label="$t('from')"
          :icon-name="icon"
          :error-text="errors?.phone?.[0] || ''"
          @keyup="keyup"
        />
      </div>
      <div class="form-card__input form-card__input--last">
        <ap-input-money
          v-model="sender.amount" 
          :error-text="errors?.amount?.[0] || ''"
          :label="$t('bank_transfer.sum_label')"
          currency
          :hint="hintText"
          @keyup="getTransferInfo"
        />
      </div>
      <div class="form-card__total total total--form-card">
        <div class="total__item">
          <div class="total__text">
            {{ remittancesToCard?.commission?.text  || 'Комиссия минимум 500 тг, перевод возможен только на карты казахстанских банков.' }} ₸
          </div>
          <div class="total__number">
            {{ remittancesToCard?.commission?.amount  || 0 }} ₸
          </div>
        </div>
        <div class="total__item">
          <div class="total__text">
            {{$t('write_off_amount')}}
          </div>
          <div class="total__number">
            {{ remittancesToCard?.commission?.total || 0 }} ₸
          </div>
        </div>
      </div>
      <div class="form-card__btn">
        <ap-button
          type="primary"
          full
          :disable="disableBtn"
          @click="pay"
        >
          <div class="button__loader">
            <div
              v-if="checking"
              class="spinner"
            />
            <div v-else>
              {{$t('continue')}}
            </div>
          </div>
        </ap-button>
      </div>
      <div class="form-card__error">
        {{ errors?.message }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
  
import { 
  PHONE_LENGTH, 
  REMITTAMCES_TO_CARD, 
  REMITTAMCES_TO_CARD_MERCHANT, 
  STATUS_OK 
} from '@/constant';
  
import { Sender } from '@/util/interface';
  
  
import apButton from './UI/apButton.vue';
import apInput from './UI/apInput.vue';
import ApInputMask from './UI/apInputMask.vue';
import ApInputMoney from './UI/apInputMoney.vue';
import apInputTel from './UI/apInputTel.vue';
  
export default defineComponent({
  components: {
    apInputTel,
    apInput,
    apButton,
    ApInputMask,
    ApInputMoney
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
      
    const sender = ref<Sender>({
      phone: '',
      amount: ''
    });
  
    const checking = ref(false);
  
  
    const btnText = ref('Продолжить');
  
    const errors = computed(() => store.getters['cardRemittancesMerchant/remittancesToCardErrors']);
    const remittancesToCard = computed(() => store.getters['cardRemittancesMerchant/remittancesToCard']);
  
    const language = computed(() => store.getters['language']);
  
    const defaultMerchant = computed(() => store.getters['isDefault']);
  
    const subtitle = computed(() => defaultMerchant.value ? ' Перевести с баланса на Visa, MasterCard, Humo или Uzcard': ' Перевести с баланса на Visa, MasterCard');
  
    const disableBtn = computed(() => {
      return !(sender.value.amount.length >= 4 && sender.value.phone.length === 10 && +sender.value.amount >= 1000 && !Object.keys(errors.value).length);
    });
  
    const hintText = computed(() =>  ''); 
  
  
    const icon = computed(() => {
      const data = store.getters['bankTransferOperator'];
      const { operator } = data;
  
      if (operator) {       
        return operator;
      }
      return '';
    });
    const clearErrors = () => {
      if (errors.value) {
        store.commit('cardRemittancesMerchant/setRemittancesToCardErrors', {});
      }
    };
    const getTransferInfo = async (): Promise<void> => {
      if (sender.value.phone.length === PHONE_LENGTH && +sender.value.amount >= 1000) {
        await store.dispatch('cardRemittancesMerchant/prevalidationRemittancesToCard', {
          amount: parseInt(sender.value.amount),
          phone: `7${sender.value.phone}`,
          description: 'Оплата с баланса телефона на карту',
          email: 'example@domain.com',
          order_id: '12356789-xyz',
          back_link: '',
          success_callback: '',
          failure_callback: '',
          language: language.value
        });
      } else {
        store.commit('cardRemittancesMerchant/setRemittancesToCard', {});
      }
    };  
  
    const keyup = () => {
      sender.value.phone.length === PHONE_LENGTH
        ? store.dispatch('checkOperator', { phone: `7${sender.value.phone}`,
          type: 'card' })
        : store.commit('setOperator', {type: 'card'});
      clearErrors();
      getTransferInfo();
    };
  
    const pay = async ():Promise<void> => {
      checking.value = true;
        
      const data = {
        amount: parseInt(sender.value.amount),
        phone: `7${sender.value.phone}`,
        description: 'Оплата с баланса телефона на карту',
        email: 'example@domain.com',
        order_id: '12356789-xyz',
        back_link: '',
        success_callback: '',
        failure_callback: '',
        language: language.value
      };
        
      btnText.value = 'Проверка данных';
      const status = await store.dispatch('cardRemittancesMerchant/prevalidationRemittancesToCard', data);
      if (status?.status === STATUS_OK) {
        btnText.value = 'Инициализация платежа';
        const otp = await store.dispatch('cardRemittancesMerchant/initializationCardRemittances', data);
        if (otp?.confirm_inputs?.length) {
          await store.dispatch('simRemittances/resendOtp',  { id: otp.id,
            language: language.value
          });

          store.commit('setOtp', {
            phone: sender.value.phone,
            service_id:  otp.id,
            paymentType: REMITTAMCES_TO_CARD_MERCHANT,
            otp: ''
          });

          router.push({ name: 'confirm',
            params: {
              phone: sender.value.phone,
              service_id: otp.id,
              paymentType: REMITTAMCES_TO_CARD_MERCHANT,
              otp: ''
            }
          });
          return;
        }
  
        router.push({ name: 'service-status',
          params: { phone: sender.value.phone,
            service_id: otp.id,
            paymentType: REMITTAMCES_TO_CARD } });
  
        btnText.value = 'Продолжить';
        return;
      }
      checking.value = false;
    };
      
    onBeforeMount(() => {
      store.commit('cardRemittancesMerchant/setRemittancesToCardErrors', {});
      store.commit('setLoading', false);
    });
  
    return {
      sender,
      pay,
      disableBtn,
      icon,
      keyup,
      errors,
      btnText,
      checking,
      subtitle,
      clearErrors,
      hintText,
      getTransferInfo,
      remittancesToCard,
      t
    };
  },
});
</script>
  <style scoped lang="scss">
  .form-card{
    background-color: $primary-white;
    border-radius: 24px;
  }
  .default{
    .form-card{
      padding: 34px 40px 40px 40px;
      &__icon{
        margin-bottom: 7px;
      }
      &__title{
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 38px;
        margin-bottom: 8px;
      }
      &__subtitle{
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
      }
      &__header{
        margin-bottom: 38px;
      }
      &__input:first-child{
        margin-bottom: 22px;
      }
      &__input{
        margin-bottom: 24px;
      }
      &__total{
        margin-bottom: 20px;
      }
    }
  }
  .tele2, .altel{
    
    .form-card{
      padding: 40px;
      background-color: #ffffff;
      &__inner{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      &__icon{
        display: none;
      }
      &__title{
        font-weight: bold;
      }
      &__subtitle{
        color: $primary-gray;
      }
      &__input:first-child {
        margin-bottom: 24px;
      }
      &__input {
        margin-bottom: 40px;
      }
      &__input--last {
        margin-bottom: 20px;
      }
      &__total{
        margin-bottom: 20px;
      }
      &__btn{
        margin: 0;
      }
    }
  }
  .tele2{
    .form-card{
      &__title{
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 38px;
        margin-bottom: 8px;
        color: $tele2-primary-black;
      }
      &__subtitle{
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        font-family: 'Open Sans',sans-serif;
        color: $tele2-primary-gray;
      }
      &__header{
        margin-bottom: 24px;
      }
    }
  }
  .altel{
    .form-card{
      padding: 40px;
      &__title{
        font-weight: 700;
        font-size: 40px;
        line-height: 48px;
        margin-bottom: 6px;
        color: $altel-primary-black;
      }
      &__subtitle{
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        color: $altel-primary-gray;
  
      }
      &__header{
        margin-bottom: 28px;
      }
    }  
  }
  @media (min-width: 320px) and (max-width: 1024px) {
    .tele2, .altel, .default{
      .form-card{
        &__title{
          font-weight: 700;
          font-size: 24px;
          line-height: 34px;
        }
      }
    }
    .default{
      .form-card{
        padding: 21px 16px 16px 16px;
      }
    }
    .tele2, .altel{
      .form-card{
        padding: 40px 16px;
      }
    }
  }
  </style>
  